import { key } from 'piqure';

export const API_BASE_URL = key<string>('api-base-url');
